module.exports = function() {
  return new Worker(__webpack_public_path__ + "a7aa06429573630c6a7a.worker.js");
};


//////////////////
// WEBPACK FOOTER
// ./src/helper/worker/downloadImages.worker.js
// module id = 239
// module chunks = 0